<app-dialog-component (okEmitter)="saveTopicDraft()" [formGroup]="topicDraftForm" [title]="title">
  <app-okr-topic-description-form [descriptionForm]="topicDraftForm"></app-okr-topic-description-form>
</app-dialog-component>
